import type { APIConstraintEnforcementMode } from '@ardoq/api-types';
import type { TripleWithContext } from './toTriplesWithContext';

export enum MetamodelConstraintsStatus {
  NONE = 'none',
  WARN = 'warning',
  DISALLOW = 'disallow',
}

/**
 * A triple the org metamodel does not describe is a constraint violation, so
 * only `isOrgTriple` is unconditionally fine. What that costs depends on the
 * organization's enforcement mode, and each surface decides what to do with the
 */
export const getTripleConstraintsStatus = (
  triple: TripleWithContext,
  constraintsEnforcementMode: APIConstraintEnforcementMode
): MetamodelConstraintsStatus => {
  if (constraintsEnforcementMode === 'off' || triple.isOrgTriple) {
    return MetamodelConstraintsStatus.NONE;
  }
  if (constraintsEnforcementMode === 'warning') {
    return MetamodelConstraintsStatus.WARN;
  }
  return MetamodelConstraintsStatus.DISALLOW;
};

export const isAllowedByEnforcementRule = (
  triple: TripleWithContext,
  constraintsEnforcementMode: APIConstraintEnforcementMode
): boolean =>
  getTripleConstraintsStatus(triple, constraintsEnforcementMode) !==
  MetamodelConstraintsStatus.DISALLOW;
